export function formatDate(dateString) {
  const dateObj = new Date(dateString);
  const options = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };
  const formattedDate = dateObj.toLocaleDateString("en-US", options);
  return formattedDate;
}
